// Third party libraries, not Foundation specific.
import 'slick-carousel/slick/slick';

const slickSliderIndex = () => {
    $(document).ready(() => {
        $('.slider-index__slides').slick({
            dots: false,
            nextArrow: false,
            prevArrow: false,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 5500,
            cssEase: 'linear',
            slidesToShow: 5,
            pauseOnHover: true,
            pauseOnFocus: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        speed: 333,
                        autoplaySpeed: 3000,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 640,
                    settings: {
                        speed: 333,
                        autoplaySpeed: 2500,
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });
};

// Module startup
const init = () => {
    slickSliderIndex();
};

export { init };
